import React, { useMemo } from "react";
import { ICarColor } from "../../../interfaces";
import CustomSelect from "../CustomSelect/CustomSelect";

interface ICarColorSelect {
  carColors: ICarColor[];
  selectedCarColor: string;
  onChange: (value: string) => void;
}

const CarColorSelect: React.FC<ICarColorSelect> = ({
  carColors,
  selectedCarColor,
  onChange,
}) => {
  const options = useMemo(
    () => carColors.map((c) => ({ value: c.id, label: c.name })),
    [carColors]
  );
  return (
    <CustomSelect
      id="car_color"
      label="Цвет"
      placeholder="Выберите цвет авто"
      options={options}
      value={selectedCarColor}
      onChange={onChange}
    />
  );
};

export default CarColorSelect;
